import { IS_DOCK, ONE_COL } from '~/lib/constants'

export const selectUI = s => s.ui
export const selectConfirm = s => s.ui.confirm
export const selectCSSPortrait = s => s.ui.isCSSPortrait
export const selectDialog = s => s.ui.dialog
export const selectShareDialog = s => s.ui.shareDialog
export const selectPage = s => s.ui.page
export const selectPending = s => s.ui.pending
export const selectTextures = s => s.ui.textures
// ⚠️ Idle counts as ready — a project with no images never warms.
export const selectTexturesReady = s => s.ui.textures.status !== 'warming'
export const selectPrompt = s => s.ui.prompt
export const selectRename = s => s.ui.rename
export const selectShow = s => s.ui.show
// `?onecol` forces it for the load without touching the stored toggle.
export const selectParamColumn = s => IS_DOCK && (ONE_COL || !!s.ui.show.param_column)
export const selectUseCustomChannel = s => s.ui.useCustomChannel

// Error queue selectors
export const selectErrors = s => s.ui.errors
export const selectCurrentError = s => s.ui.errors[0] || null
